import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ISlide, TutorialService } from 'src/app/tutorial/tutorial.service';

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TutorialComponent implements OnInit {
  slides$ = new BehaviorSubject<ISlide[]>([]);
  isOpen = true;
  private navigatingToMood = false;

  constructor(private service: TutorialService, private router: Router) {}

  ngOnInit(): void {
    this.slides$.next(this.service.tutorialData);
    this.isOpen = true;
  }

  async toHome(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();

    if (this.navigatingToMood) {
      return;
    }

    this.navigatingToMood = true;
    this.isOpen = false;

    const modal = document.querySelector(
      'ion-modal.tutorial-onboarding-modal'
    ) as HTMLIonModalElement | null;

    try {
      await modal?.dismiss(null, 'get-started');
    } catch {
      // The bound isOpen state still closes the modal if Ionic has already removed it.
    }

    try {
      await this.router.navigate(['/mood'], {
        replaceUrl: true,
      });
    } catch {
      this.navigatingToMood = false;
      this.isOpen = true;
    }
  }
}
